import type { AcuityApproversResponse } from "@/core/types";
import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";

export async function getAcuityApprovers(): Promise<AcuityApproversResponse> {
  return acuityRequestsTyped.get_approvers({ context: { showLoader: false } });
}
